/*
 * SPDX-FileCopyrightText: 2024 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { RendererStatus } from './types'

export const initialState: RendererStatus = {
  rendererReady: false
}
